<template>
    <div class="xScrollable">
        <table class="kgr-table kgr-table--block kgr-table--striped data-table table-groups printable">
            <thead>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        <input
                            type="checkbox"
                            @change="$emit('selectAll')"
                        />
                    </td>
                    <td
                        class="kgr-table__cell"
                        :colspan="colspan"
                    >
                        <div class="kgr-accordion__itemHeadline">
                            &nbsp;{{ headline }}
                            <kgr-icon
                                class="kgr-icon kgr-icon--tiny openConfig"
                                icon-class="settings"
                                :title="tOpenTableConfig"
                                @click="openTableConfigurationDialog()"
                            />
                        </div>
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                    </th>
                    <th
                        v-if="isExamOfferingForDogs && showColumn(TableColumn.DOG)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingDogName }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.NAME)"
                        class="kgr-table__cell kgr-table__cell--headline">
                        {{ tBookingName }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingContractStatus }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.AGE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingAge }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.EMAIL)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingEmail }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.PHONE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingPhone }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.PHONE_MOBILE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingPhoneMobile }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tEmergencyContact }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.BOOKED_AT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingBookedAt }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.CANCELED_AT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingCanceledAt }}
                    </th>
                    <th v-show="showColumn(TableColumn.ATTENDEE_STATUS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingStatus }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.COMMENT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingComment }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.CONTRACT_END)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingContractEnd }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.DEPARTMENTS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingDepartments }}
                    </th>
                    <th
                        v-show="isExamOfferingForDogs && showColumn(TableColumn.ADDRESS_PARTICIPANT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingAddressParticipant }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ tBookingAction }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-if="pending"
                >
                    <td :colspan="colspan">
                        <kgr-loading />
                    </td>
                </tr>
                <template v-else>
                    <tr
                        v-for="booking in bookings"
                        :key="booking.id"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <input
                                :id="booking.member.id"
                                v-model="booking.checked"
                                type="checkbox"
                                :value="booking.member.email"
                                @change="$emit('bookingChecked', {id: booking.id, checked: booking.checked})"
                            />
                        </td>
                        <td
                            v-if="isExamOfferingForDogs && showColumn(TableColumn.DOG)"
                            class="kgr-table__cell"
                        >
                            <a
                                v-if="booking.dog && offering.canViewDogs"
                                :href="dogLink(booking.dog.id)"
                                target="_blank"
                                class="kgr-link"
                            >
                                {{ booking.dog.name }}
                            </a>
                            <span v-else-if="booking.dog">{{ booking.dog.name }}</span>
                        </td>
                        <td
                            v-show="showColumn(TableColumn.NAME)"
                            class="kgr-table__cell"
                        >
                            <a
                                v-if="booking.canViewShortProfile"
                                :href="memberLink(booking.member.id)"
                                target="_blank"
                                class="kgr-link"
                            >
                                {{ booking.member.fullName() }}
                            </a>
                            <template v-else>{{ booking.member.fullName() }}</template>
                        </td>
                        <td
                            v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                            class="kgr-table__cell kgr-table__cell--noGrow"
                            :data-order="booking.member.contractState.status"
                        >
                            <kgr-member-contract-state-icon :state="booking.member.contractState" />
                        </td>
                        <td
                            v-show="showColumn(TableColumn.AGE)"
                            class="kgr-table__cell"
                        >
                            {{ booking.member.age }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.EMAIL)"
                            class="kgr-table__cell"
                        >
                            <a
                                v-if="booking.member.email"
                                :href="'mailto:' + booking.member.email"
                                @click="$emit('copyMailAddress', booking.member.email)"
                                :title="booking.member.email"
                            >
                                <kgr-icon
                                    class="kgr-icon kgr-icon--small"
                                    icon-class="email"
                                />
                            </a>
                        </td>
                        <td
                            v-show="showColumn(TableColumn.PHONE)"
                            class="kgr-table__cell"
                        >
                            {{ booking.member.phone }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.PHONE_MOBILE)"
                            class="kgr-table__cell"
                        >
                            {{ booking.member.phoneMobile }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                            class="kgr-table__cell"
                        >
                            {{ booking.member.emergencyContact }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.BOOKED_AT)"
                            class="kgr-table__cell"
                        >
                            {{ getBookedAtDate(booking) }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.CANCELED_AT)"
                            class="kgr-table__cell"
                        >
                            {{ getCancelDate(booking) }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.ATTENDEE_STATUS)"
                            class="kgr-table__cell"
                        >
                            {{ $t('attendanceList.member.status.' + booking.attendeeStatus) }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.COMMENT)"
                            class="kgr-table__cell"
                        >
                            {{ booking.comment }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.CONTRACT_END)"
                            class="kgr-table__cell"
                        >
                            {{ formatContractEnd(booking.member.contractEnd) }}
                        </td>
                        <td
                            v-show="showColumn(TableColumn.DEPARTMENTS)"
                            class="kgr-table__cell"
                        >
                            {{ parseMemberDepartments(booking.member) }}
                        </td>
                        <td
                            v-show="isExamOfferingForDogs && showColumn(TableColumn.ADDRESS_PARTICIPANT)"
                            class="kgr-table__cell"
                        >
                            {{ parseMemberAddress(booking.member) }}
                        </td>
                        <td class="kgr-table__cell">
                            <template v-if="booking.canAcceptOrReject">
                                <kgr-icon
                                    v-if="canReject"
                                    class="kgr-icon"
                                    icon-class="cancel"
                                    :title="$t('offering.cancelBooking')"
                                    @click="confirmCancelBooking(booking)"
                                />
                                <kgr-icon
                                    v-if="canAccept"
                                    class="kgr-icon"
                                    icon-class="check"
                                    :title="$t('offering.acceptBooking')"
                                    @click="$emit('acceptBooking', booking.id)"
                                />
                                <kgr-icon
                                    v-if="booking.isEditable && canReject"
                                    icon-class="edit"
                                    small
                                    :title="$t('offering.editBooking')"
                                    @click="openEditOfferingBookingDialog(booking)"
                                />
                            </template>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <br />
        <kgr-table-configuration
            ref="tableConfiguration"
            :offering="offering"
            :table-columns="tableColumns"
            :user-id="userId"
            :show-dialog="showTableConfiguration"
            :type="tableType"
            @change="updateColumns"
            @closeDialog="closeTableConfigurationDialog()"
        />
        <kgr-edit-offering-booking
            v-if="editOfferingBooking && showEditOfferingBooking"
            :offering="offering"
            :offering-booking="editOfferingBooking"
            :show-dialog="showEditOfferingBooking"
            @closeDialog="closeEditOfferingBookingDialog()"
            @update:offeringBooking="$emit('update:offeringBooking')"
        />
    </div>
</template>

<script>
import EditOfferingBooking from './EditOfferingBooking.vue';
import Icon from '../../common/icon/Icon.vue';
import KgrMemberContractStateIcon from '../../members/MemberContractStateIcon.vue';
import Loading from '../../common/Loading.vue';
import Offering from '../../../js/dto/offering/Offering.js';
import TableColumn from '../../../js/dto/offering/TableColumn.js';
import TableConfiguration from './TableConfiguration.vue';
import moment from 'moment';

export default {
    name: 'KgrGenericAppointmentParticipantTable',
    components: {
        'kgr-edit-offering-booking': EditOfferingBooking,
        'kgr-icon': Icon,
        'kgr-loading': Loading,
        'kgr-member-contract-state-icon': KgrMemberContractStateIcon,
        'kgr-table-configuration': TableConfiguration,
    },
    props: {
        bookings: {
            type: Array,
            required: true,
        },
        headline: {
            type: String,
            required: true,
        },
        canAccept: {
            type: Boolean,
            required: false,
            default: false
        },
        canReject: {
            type: Boolean,
            required: false,
        },
        pending: {
            type: Boolean,
            required: false,
            default: false
        },
        offering: {
            type: Offering,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        tableColumns: {
            type: Array,
            required: true,
        },
        tableForCancellations: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            cancelBookingId: null,
            showTableConfiguration: false,
            selectedColumns: null,
            showEditOfferingBooking: false,
            editOfferingBooking: null,
        }
    },
    computed: {
        TableColumn () {
            return TableColumn;
        },
        colspan() {
            if (!this.selectedColumns) {
                return this.offering.isExamForDogs() ? 16 : 15;
            }
            return this.selectedColumns.length + 1;
        },
        tOpenTableConfig() {
            return this.$t('offering.tableConfig');
        },
        isExamOfferingForDogs() {
            return this.offering.isExamForDogs()
        },
        tBookingName() {
            return this.$t('Name');
        },
        tBookingContractStatus() {
            return this.$t('booking.contractStatus');
        },
        tBookingAge() {
            return this.$t('booking.age');
        },
        tBookingEmail() {
            return this.$t('booking.email');
        },
        tBookingPhone() {
            return this.$t('booking.phone');
        },
        tBookingPhoneMobile() {
            return this.$t('booking.phoneMobile');
        },
        tEmergencyContact() {
            return this.$t('booking.emergencyContact');
        },
        tBookingBookedAt() {
            return this.$t('booking.bookedAt');
        },
        tBookingCanceledAt() {
            return this.$t('storniert am');
        },
        tBookingStatus() {
            return this.$t('booking.attendeeStatus');
        },
        tBookingComment() {
            return this.$t('booking.comment');
        },
        tBookingContractEnd() {
            return this.$t('booking.contractEnd');
        },
        tBookingDepartments() {
            return this.$t('Abteilungen');
        },
        tBookingAddressParticipant() {
            return this.$t('booking.addressParticipant');
        },
        tBookingAction() {
            return this.$t('Aktion');
        },
        tBookingDogName() {
            return this.$t('booking.dog');
        },
        tableType() {
            return this.tableForCancellations ? TableColumn.TABLE_TYPE_CANCELLATIONS : TableColumn.TABLE_TYPE_PARTICIPANTS;
        },
    },
    methods: {
        memberLink(memberId) {
            return `/backend/clubs/members/${memberId}/show`;
        },
        dogLink(dogId) {
            return `/backend/clubs/dogs/${dogId}/show`;
        },
        formattedDateTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
        },
        getBookedAtDate(offeringBooking) {
            return this.formattedDateTime(offeringBooking.bookedAt.date)
                + ' ('
                + (offeringBooking.bookedByClub ? this.$t('Verein') : this.$t('booking.bookedByParticipant'))
                + ')';
        },
        getCancelDate(offeringBooking) {
            if (offeringBooking.canceledAt) {
                return offeringBooking.canceledAt + ' (' + this.$t('booking.canceledByParticipant') + ')';
            } else if (offeringBooking.canceledByClubAt) {
                return offeringBooking.canceledByClubAt + ' (' + this.$t('Verein') + ')';
            } else {
                return '-';
            }
        },
        confirmCancelBooking(booking) {
            let confirmMessage = this.$t('booking.cancel.confirm', {});
            showConfirm(this.$t('confirm'), confirmMessage, () => {
                this.confirmInform(booking.id);
            }, 'Ok');
        },
        confirmInform(bookingId) {
            this.cancelBookingId = bookingId;
            var cancelBookingWithInform = this.cancelBookingWithInform.bind({this: this});
            var cancelBookingWithoutInform = this.cancelBookingWithoutInform.bind({this: this});
            showConfirmYesNo(this.$t('confirm'), this.$t('booking.cancelInform.confirm'),
                function () {
                    cancelBookingWithInform()
                },
                function () {
                    cancelBookingWithoutInform()
                }
            );
        },
        cancelBookingWithInform() {
            this.cancelBooking(this.cancelBookingId, true);
        },
        cancelBookingWithoutInform() {
            this.cancelBooking(this.cancelBookingId, false);
        },
        cancelBooking(bookingId, inform) {
            this.$emit('cancelBooking', {id: bookingId, inform: inform});
        },
        openTableConfigurationDialog() {
            this.showTableConfiguration = true;
        },
        closeTableConfigurationDialog() {
            this.showTableConfiguration = false;
        },
        updateColumns() {
            this.selectedColumns = this.$refs.tableConfiguration.loadConfiguration();
        },
        showColumn(column) {
            if (!this.selectedColumns) {
                return true;
            }
            return this.selectedColumns.includes(column);
        },
        getSelectedColumns() {
            return this.selectedColumns;
        },
        formatContractEnd(contractEnd) {
            return contractEnd ? moment(contractEnd, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
        },
        parseMemberDepartments(member) {
            return member.departments ? member.departments.join(', ') : '';
        },
        parseMemberAddress(member) {
            return (member.street ? (member.street + ', ') : '') + member.zip + ' ' + member.city;
        },
        openEditOfferingBookingDialog(offeringBooking) {
            this.editOfferingBooking = offeringBooking;
            this.showEditOfferingBooking = true;
        },
        closeEditOfferingBookingDialog() {
            this.editOfferingBooking = null;
            this.showEditOfferingBooking = false;
        },
    },
    mounted() {
        this.updateColumns()
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.openConfig {
    float: right;
    margin-right: 20px;
}
.xScrollable {
    overflow-x: auto;
}
</style>
